import { action, makeObservable, observable } from 'mobx';
import { nanoid } from 'nanoid';
import Service from '../util/Service';
export class FeatureValueStore {
    constructor({ id, description, title, granted, }) {
        this.granted = undefined;
        this.modified = false;
        makeObservable(this, {
            granted: observable,
            setGranted: action,
            setModified: action,
            modified: observable,
        });
        this.id = id;
        this.description = description;
        this.title = title;
        this.granted = granted;
        this.$fid = nanoid();
        this.service = new Service();
    }
    change(value) {
        if (value !== this.granted) {
            this.setGranted(value);
            this.setModified(true);
            this.service.fireEvent({
                name: 'consents/CHANGE',
                level: 'info',
                message: 'user changed a consent',
            });
        }
    }
    setGranted(granted) {
        this.granted = granted;
    }
    setModified(modified) {
        this.modified = modified;
    }
    get fid() {
        return this.$fid;
    }
    toJSON() {
        return {
            ...this,
        };
    }
    toSaveFeatureValue() {
        const { id, granted = false } = this;
        return { id, granted };
    }
    toShortFeatureValue() {
        return this.toSaveFeatureValue();
    }
}
//# sourceMappingURL=FeatureValueStore.js.map